module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"percentage":"Porcentual increment %","fixed":"Fixed Increment €","groups":"Groups of products:"},"es":{"percentage":"Incremento porcentual %","fixed":"Incremento fijo €","groups":"Grupos de productos:"}}')
  delete Component.options._Ctor
}
